/**
 * Moves keyboard focus to same-page hash targets after navigation (WCAG 2.4.3).
 * Native scroll-to-#id does not move focus; this supplements it without blocking scroll.
 */
(function () {
  /**
   * @param {string} hash
   */
  function focusHashTarget(hash) {
    if (!hash || hash === '#') return;
    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch {
      return;
    }
    if (!id) return;

    const target = document.getElementById(id);
    if (!(target instanceof HTMLElement)) return;

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  document.documentElement.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[href^="#"]');
      if (!(link instanceof HTMLAnchorElement)) return;
      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch {
        return;
      }

      if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;

      const id = url.hash.slice(1);
      if (!id) return;
      if (!document.getElementById(decodeURIComponent(id))) return;

      window.requestAnimationFrame(() => {
        focusHashTarget(url.hash);
      });
    },
    true
  );

  window.addEventListener('hashchange', () => {
    focusHashTarget(window.location.hash);
  });

  if (window.location.hash) {
    window.addEventListener('load', () => {
      window.requestAnimationFrame(() => focusHashTarget(window.location.hash));
    });
  }
})();
